import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, Card, CardActions, CardContent, Chip, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { couponsPathTo } from '../utils/Api';
import SnackbarContext from '../contexts/SnackbarContext';
import { currency } from './building_blocks/Currency';

const statusLabel = {
  active: 'Ativo',
  disabled: 'Desabilitado',
};

const statusColor = {
  active: 'success',
  disabled: 'default',
};

const formatDateTime = (value) => {
  if (!value) return '-';

  return new Date(value).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const CouponList = () => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { openSnackbar, openConfirmDialog } = useContext(SnackbarContext);

  const loadCoupons = () => {
    setLoading(true);
    couponsPathTo
      .list()
      .then((result) => setCoupons(result.data))
      .catch(() => openSnackbar('Não foi possível carregar os cupons.', 'error'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    document.title = 'Cupons - TudoPets.app';
    loadCoupons();
  }, []);

  const handleDisable = (coupon) => {
    openConfirmDialog('Desabilitar este cupom? Quem ainda não resgatou não vai conseguir usar o link.', async () => {
      try {
        const result = await couponsPathTo.update(coupon.id, { status: 'disabled' });
        setCoupons(coupons.map((item) => (item.id === coupon.id ? result.data : item)));
        openSnackbar('Cupom desabilitado.', 'success');
      } catch (error) {
        openSnackbar(error?.response?.data?.errors?.[0] || 'Não foi possível desabilitar o cupom.', 'error');
      }
    });
  };

  if (loading) {
    return <Typography>Carregando cupons...</Typography>;
  }

  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography variant="h4" color="primary">
          Cupons
        </Typography>
        <Button variant="contained" onClick={() => navigate('/control-center/coupons/new')}>
          Criar cupom
        </Button>
      </Box>

      <Stack spacing={2}>
        {coupons.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            Nenhum cupom criado ainda.
          </Typography>
        )}

        {coupons.map((coupon) => (
          <Card key={coupon.id} variant="outlined">
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
                <Typography variant="h6">{coupon.name}</Typography>
                <Chip
                  label={statusLabel[coupon.status] || coupon.status}
                  color={statusColor[coupon.status] || 'default'}
                  size="small"
                />
              </Box>

              <Typography variant="body2" color="text.secondary">
                Código: {coupon.code}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Desconto: {currency(coupon.discount_value)}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Usos: {coupon.redemptions_count}/{coupon.max_redemptions}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Vence em {formatDateTime(coupon.expires_at)}
              </Typography>
            </CardContent>

            <CardActions sx={{ justifyContent: 'flex-end', flexWrap: 'wrap' }}>
              <Button variant="outlined" onClick={() => navigate(`/control-center/coupons/${coupon.id}`)}>
                Abrir
              </Button>
              {coupon.status === 'active' && (
                <Button variant="outlined" color="warning" onClick={() => handleDisable(coupon)}>
                  Desabilitar
                </Button>
              )}
            </CardActions>
          </Card>
        ))}
      </Stack>
    </Box>
  );
};

export default CouponList;
